<template>
  <div class="pb100">
    <crumbs detail="true"/>
    <div class="container">
      <div class="detailmodel1 clearfix">
        <div class="leftcon fl">
          <h2 class="title">{{ detail.name }}</h2>
          <div class="imgtxtbox clearfix">
            <div class="imgbox fl">
              <div class="imgboxinner">
                <i class="icon-scale1"></i>
                <img class="imgtop" preview="0" :src="getImage(detail.imageUrl)" alt="">
              </div>
              <div class="labelbox">
                <el-button size="small" round
                           v-if="detail.businessTypeList && detail.businessTypeList.length > 0"
                           v-for="(item, index) in detail.businessTypeList"
                           :key="index">{{ item }}</el-button>
              </div>
            </div>
            <div class="txtbox fr">
              <div class="con_detail">
                <p class="icon icon2" v-if="detail.money !== undefined && detail.money !== ''">票价<em class="red">{{ detail.money }}</em></p>
                <p class="icon icon4"> 时间
                  <input type="text" :value="getTime(detail.startTime)" disabled="disabled">
                  <input type="text" :value="getTime(detail.endTime)" disabled="disabled">
                </p>
                <p class="icon icon6" v-if="detail.number !== undefined && detail.number !== ''">场次 {{ detail.number }}</p>
                <p class="icon icon6" v-if="detail.sponsor !== undefined && detail.sponsor !== ''">单位 {{ detail.sponsor }}</p>
                <p class="icon icon5" v-if="detail.phone !== undefined && detail.phone !== ''">联系电话 {{ detail.phone }}</p>
                <p class="icon icon6" v-if="detail.touchName !== undefined && detail.touchName !== ''">联系人 {{ detail.touchName }}</p>
              </div>
              <star star-style="iconstar3"
                    v-if="detail.persionalCommon"
                    :is-select="detail.persionalCommon.isStar"
                    :count="detail.persionalCommon.starCount"
                    @changecount="changeStar"
                    :showzero="true"
                    :menu-id="this.$route.query.columnId"
                    :business-id="this.$route.query.id"
                    :title="detail.name"
                    :image="11"
                    :url="this.$route.fullPath"/>
            </div>
          </div>
          <div class="contentbox" v-html="detail.content"></div>
          <comment v-if="detail" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
        </div>
        <div class="rightcon fr">
          <h2 class="title">推荐</h2>
          <ul>
            <li v-for="(item, index) in List" :key="index">
              <router-link :to="'/culturedistributiondetail?columnId=' + item.menuId + '&id=' + item.id">
                <div class="imgbox">
                  <img class="imgtop" :src="getImage(item.image)" alt="">
                </div>
                <h4 class="textover">{{ item.name }}</h4>
              </router-link>
            </li>
          </ul>
          <nodata v-show="nodataflag"/>
        </div>
      </div>
    </div>
    <go-top></go-top>
    <right-sidebar
      :stardisplay="false"
      :comment-count="commentTotal"
      :comment-gotop="commentOffsettop"
      :comment-show="isCommentshow"
      :title="detail.name"
      :image="getImage(detail.imageUrl)"
      :url="this.$route.fullPath"
      ref="rightSidebar"></right-sidebar>
  </div>
</template>

<script>
import Vue from 'vue'
import { timeFormat } from '@/utils/validate'
import { getCultureDistributionList, getCultureDistributionDetail } from '@/api/culturedistribution/index'
import crumbs from '@/components/crumbs/index'
import goTop from '@/components/gotop/index'
import RightSidebar from '@/components/rightsidebar/index'
import Comment from '@/components/comment/index'
import Star from '@/components/amount/star'
import nodata from '@/components/nodata/index'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)
export default {
  name: 'culturedistributiondetail',
  meta: {
    showHeader: true
  },
  components: {
    crumbs,
    goTop,
    RightSidebar,
    Comment,
    Star,
    nodata
  },
  data () {
    return {
      Param: {
        page: 1,
        limit: 5,
        menuId: this.$route.query.columnId,
        recommend: 1
      },
      star: 0,
      starflag: false,
      nodataflag: false,
      List: [],
      detail: '',
      commentTotal: '',
      commentOffsettop: '',
      isCommentshow: true // 是否显示评论
    }
  },
  mounted () {
    this.getDetail()
    this.getrecommend()
  },
  methods: {
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    getTime (val) {
      return timeFormat(val, 'yymmddhhmm')
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    changeStar (val) {
      this.detail.persionalCommon.starCount = val.count
      this.detail.persionalCommon.isStar = val.isSelect
    },
    getrecommend () {
      getCultureDistributionList(this.Param).then(res => {
        if (res.data.status === 0) {
          this.listTotal = res.data.totalSize
          if (this.listTotal === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          this.List = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    getDetail () {
      getCultureDistributionDetail(this.$route.query.id, { 'menuId': this.$route.query.columnId }).then(res => {
        this.detail = res.data
        console.log(this.detail)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .appointmentcontainer{
    padding: 0 0 100px;
  }
</style>



// WEBPACK FOOTER //
// src/view/culturedistribution/detail.vue